import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { CacheProvider } from "./lib/cache";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import ResumenSemanal from "./pages/ResumenSemanal";
import ClientesPage from "./pages/ClientesPage";
import EjecutivosPage from "./pages/EjecutivosPage";
import ForecastGlobalPage from "./pages/ForecastGlobalPage";
import CoberturaMercadoPage from "./pages/CoberturaMercadoPage";
import CargarDatosPage from "./pages/CargarDatosPage";
import ModeloPage from "./pages/ModeloPage";

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-indigo-600 border-t-transparent rounded-full" />
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Public Route wrapper (redirect if authenticated)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-indigo-600 border-t-transparent rounded-full" />
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />

      {/* Protected routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <ResumenSemanal />
        </ProtectedRoute>
      } />
      
      <Route path="/clientes" element={
        <ProtectedRoute>
          <ClientesPage />
        </ProtectedRoute>
      } />
      
      <Route path="/clientes/:clientId" element={
        <ProtectedRoute>
          <ClientesPage />
        </ProtectedRoute>
      } />
      
      <Route path="/ejecutivos" element={
        <ProtectedRoute>
          <EjecutivosPage />
        </ProtectedRoute>
      } />
      
      <Route path="/ejecutivos/:executiveId" element={
        <ProtectedRoute>
          <EjecutivosPage />
        </ProtectedRoute>
      } />
      
      <Route path="/forecast" element={
        <ProtectedRoute>
          <ForecastGlobalPage />
        </ProtectedRoute>
      } />
      
      {/* Redirect old simulator route to forecast */}
      <Route path="/simulador" element={<Navigate to="/forecast" replace />} />
      
      <Route path="/cobertura" element={
        <ProtectedRoute>
          <CoberturaMercadoPage />
        </ProtectedRoute>
      } />
      
      <Route path="/cargar-datos" element={
        <ProtectedRoute>
          <CargarDatosPage />
        </ProtectedRoute>
      } />
      
      {/* Redirect old route */}
      <Route path="/ingresar-datos" element={<Navigate to="/cargar-datos" replace />} />
      
      <Route path="/modelo" element={
        <ProtectedRoute>
          <ModeloPage />
        </ProtectedRoute>
      } />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CacheProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </CacheProvider>
    </BrowserRouter>
  );
}

export default App;
